import { OverlayModule } from '@angular/cdk/overlay';
import { PortalModule } from '@angular/cdk/portal';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { PalantirSelectItemOverlayComponent } from './select-item-overlay.component';
import { PalantirSelectItemOverlayDirective } from './select-item-overlay.directive';
import { PalantirSelectItemOverlayService } from './select-item-overlay.service';

@NgModule({
  imports: [
    CommonModule,
    OverlayModule,
    PortalModule,
    PalantirSelectItemOverlayComponent,
    PalantirSelectItemOverlayDirective,
  ],
  providers: [PalantirSelectItemOverlayService],
  exports: [PalantirSelectItemOverlayComponent, PalantirSelectItemOverlayDirective],
})
export class PalantirSelectItemOverlayModule {}
